import React, { useState, useMemo } from 'react';
import { Segment } from 'tea-component';
import useRPDBarCharts from '@/pages/intelligence/pages/TopCharts/MobileGames/hooks/useRPDBarCharts';
import CountryTable from './Table';
import CardSlotV2 from '@/pages/intelligence/components/CardSlotV2';
import Visualis from './Visualis';
import CardStats from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/components/CardStats';
import useIntlExtend from '@intelligence/hooks/useIntlExtend';
import { useMobileOptionList } from '@/pages/intelligence/pages/TopCharts/_hooks/useMobileOptionList';
import { IconFourList } from '@intelligence/components/CardSlotV2';
import { getCountriesCardTitleI18nKey } from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/_config/countriesCardTitle';

const CountriesCard = (props: any) => {
  const {
    loading,
    tableData = [],
    lineData = [],
    chartType,
    setChartType,
    changeSegement,
    changeSegementRight,
    cardStatus,
    topChartsType = 'stats-rpdedition-bar-country',
    metricSegVal,
    setMetricSegVal,
    regionsCountries,
    marketChartList,
    fixedTableData,
    asForDate,
    dateType,
    chartLineLoading,
    baseReleaseTime,
    earliestPeriod,
    earliestDay,
    startDate,
    endDate,
    countriesType: regionSegVal,
    pageSortAttr,
    onTableSortChage,
    entityType,
    dataSource,
    lineXAxisData,
  } = props;

  // console.log('CountriesCard333',props);

  const { rpdSegementOptions, rpdSegementTitleObj } = useMobileOptionList();

  const { formatMessage } = useIntlExtend(); // 中英切换方法
  const { isLoading, isError, isNoData } = cardStatus || {};
  // const [regionSegVal, setRegionSegVal] = useState('market');
  const [chartLoading, setChartLoading] = useState(true);
  // const [metricSegVal, setMetricSegVal] = useState(rpdSegementOptions[0].value);

  // 柱状图相关hooks
  const { seriesData: barSeriesData, barNameList } = useRPDBarCharts(
    metricSegVal,
    marketChartList,
    topChartsType,
    'countries',
  );

  const countriesSharTitle = useMemo(() => {
    const titleI18nKey = getCountriesCardTitleI18nKey({
      dimension: regionSegVal,
      metric: metricSegVal,
      chartType,
    });

    return formatMessage({ id: titleI18nKey });
  }, [regionSegVal, metricSegVal, chartType, formatMessage]);

  if (isLoading || isNoData || isError) {
    return (
      <CardSlotV2 className="dbi-mobileGames-card-context" title={countriesSharTitle} iconList={[]}>
        <CardStats cardStatus={cardStatus} />
      </CardSlotV2>
    );
  }

  return (
    <div className="dbi-countries-card">
      <CardSlotV2
        className="dbi-mobileGames-card-context"
        title={countriesSharTitle}
        rightText={
          earliestDay ? `${formatMessage({ id: `dbi_detail_earliest_date` })}: ${earliestDay}` : ''
        }
        rightTip={earliestDay ? formatMessage({ id: `dbi_detail_earlistdate_info` }) : ''}
        disableChartType={['pie']}
        activeTab={chartType}
        iconList={IconFourList}
        getChange={(value: any) => {
          setChartType(value);
          setChartLoading(true);
        }}
      >
        <div className="retention-segment">
          <Segment
            className="segment-right"
            value={regionSegVal}
            onChange={(value) => {
              // setRegionSegVal(value);
              changeSegement(value);
              setChartLoading(true);
            }}
            options={[
              { text: formatMessage({ id: 'dbi_game_detail_countries' }), value: 'market' },
              { text: formatMessage({ id: 'dbi_game_detail_region' }), value: 'region' },
            ]}
          />
          <Segment
            value={metricSegVal}
            onChange={(value) => {
              setMetricSegVal(value);
              changeSegementRight(value);
              setChartLoading(true);
            }}
            options={rpdSegementOptions}
          />
        </div>
        <div className="trends-card-line">
          <Visualis
            chartType={chartType}
            lineData={lineData}
            barData={marketChartList}
            barSeriesData={barSeriesData}
            barNameList={barNameList}
            topChartsType={topChartsType}
            chartSegment={metricSegVal}
            barOrPieData={marketChartList}
            titleNow={rpdSegementTitleObj[metricSegVal]}
            regionSegVal={regionSegVal}
            chartLoading={chartLoading}
            chartLineLoading={chartLineLoading}
            setChartLoading={setChartLoading}
            regionsCountries={regionsCountries}
            dateType={dateType}
            baseReleaseTime={baseReleaseTime}
            earliestPeriod={earliestPeriod}
            isStackLine={chartType === 'stackedLine'}
            startDate={startDate}
            endDate={endDate}
            lineXAxisData={lineXAxisData}
          />
        </div>
        <CountryTable
          loading={loading}
          chartSegment={metricSegVal} /** 用于表格展示排序 */
          tableData={tableData}
          fixedTableData={fixedTableData}
          regionSegVal={regionSegVal}
          asForDate={asForDate}
          pageSortAttr={pageSortAttr}
          onTableSortChage={onTableSortChage}
          entityType={entityType}
          dataSource={dataSource}
        />
      </CardSlotV2>
    </div>
  );
};

export default CountriesCard;
